// Portfolio carousels — scroll-snap horizontal por row, com prev/next
// buttons (smooth scroll por card width + gap), progress thumb (largura
// proporcional ao viewport ÷ scrollWidth, marginLeft proporcional ao
// scrollLeft), e disabled state em min/max.
// Portado de qualiapps-lading-page.html linhas 3954-3985.

export function initPortfolioCarousel(): void {
  const rows = document.querySelectorAll<HTMLElement>(".portfolio-row");
  for (const row of rows) initRow(row);
}

function initRow(row: HTMLElement): void {
  const scroller = row.querySelector<HTMLElement>(".scroller");
  if (!scroller) return;

  const prev = row.querySelector<HTMLButtonElement>(".nav-btn.prev");
  const next = row.querySelector<HTMLButtonElement>(".nav-btn.next");
  const thumb = row.querySelector<HTMLElement>(".progress > i");

  function getStep(): number {
    if (!scroller) return 0;
    const card = scroller.querySelector<HTMLElement>(".proj-card");
    if (!card) return scroller.clientWidth;
    const style = getComputedStyle(scroller);
    const gapStr = style.columnGap || style.gap || "16";
    const gap = parseFloat(gapStr) || 16;
    return card.getBoundingClientRect().width + gap;
  }

  function update(): void {
    if (!scroller) return;
    const max = scroller.scrollWidth - scroller.clientWidth;
    const ratio = max <= 0 ? 1 : scroller.clientWidth / scroller.scrollWidth;
    const pos = max <= 0 ? 0 : scroller.scrollLeft / max;
    if (thumb) {
      thumb.style.width = `${ratio * 100}%`;
      thumb.style.marginLeft = `${pos * (1 - ratio) * 100}%`;
    }
    if (prev) prev.disabled = scroller.scrollLeft <= 4;
    if (next) next.disabled = scroller.scrollLeft >= max - 4;
  }

  if (prev) {
    prev.addEventListener("click", () => {
      scroller.scrollBy({ left: -getStep(), behavior: "smooth" });
    });
  }
  if (next) {
    next.addEventListener("click", () => {
      scroller.scrollBy({ left: getStep(), behavior: "smooth" });
    });
  }

  scroller.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  update();
}
